import React, { useState } from 'react';
import { UserIcon, PencilRulerIcon, CalendarIcon, EyeIcon, EditIcon, DownloadIcon, ShareIcon, RulerIcon, PieChartIcon, DropletIcon, TagIcon, ChevronRightIcon, ChevronLeftIcon, ListIcon, LayoutGridIcon, FoldersIcon } from 'lucide-react';
import { FolderView } from './FolderView';
// Mock data for shared designs
const sharedDesignsData = [{
  id: 'SD001',
  name: 'North Valley Project',
  description: 'Shared by AiscoEurope SAU',
  date: 'Aug 10, 2025',
  status: 'active',
  model: 'Pivot CP600',
  pivotCount: 2,
  specs: {
    length: '300.00 m',
    angle: '360°',
    area: '35.00 ha',
    flow: '38.50 l/s',
    pressure: '2.20 bar'
  },
  sharedBy: 'Daniel Fernández',
  sharedDate: '2025-08-10',
  tags: ['Multi-Pivot', 'Valley']
}, {
  id: 'SD002',
  name: 'Riverside Linear Setup',
  description: 'Shared by HMB Irrigation',
  date: 'Jul 25, 2025',
  status: 'completed',
  model: 'Linear',
  pivotCount: 1,
  specs: {
    length: '350.00 m',
    angle: 'N/A',
    area: '40.00 ha',
    flow: '45.00 l/s',
    pressure: '2.50 bar'
  },
  sharedBy: 'Benny Ginter',
  sharedDate: '2025-07-25',
  tags: ['Linear', 'Riverside']
}];
export function SharedDesigns({
  searchQuery,
  selectedDealer,
  selectedRegion,
  selectedModel
}) {
  const [viewType, setViewType] = useState('grid'); // 'grid', 'list', or 'folders'
  // Filter designs based on search query and model
  const filteredDesigns = sharedDesignsData.filter(design => {
    const matchesSearch = searchQuery === '' || design.id.toLowerCase().includes(searchQuery.toLowerCase()) || design.name.toLowerCase().includes(searchQuery.toLowerCase()) || design.description.toLowerCase().includes(searchQuery.toLowerCase()) || design.sharedBy.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesModel = selectedModel === 'all' || design.model.toLowerCase().includes(selectedModel.toLowerCase());
    return matchesSearch && matchesModel;
  });
  const handleViewDesign = design => {
    console.log('Viewing design:', design);
    // Aquí implementarías la lógica para ver un diseño
  };
  return <div data-id="element-2795">
      {/* Dashboard summary */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 border-b border-gray-200 bg-gray-50" data-id="element-2796">
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2797">
          <div className="flex justify-between items-start" data-id="element-2798">
            <div data-id="element-2799">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2800">
                Shared With Me
              </h3>
              <p className="text-4xl font-bold text-indigo-600" data-id="element-2801">
                {filteredDesigns.length}
              </p>
            </div>
            <div className="bg-indigo-100 p-2 rounded-lg" data-id="element-2802">
              <ShareIcon size={24} className="text-indigo-600" data-id="element-2803" />
            </div>
          </div>
          <div className="mt-4 text-sm text-gray-600" data-id="element-2804">
            From {new Set(filteredDesigns.map(d => d.sharedBy)).size}{' '}
            collaborators
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2805">
          <div className="flex justify-between items-start" data-id="element-2806">
            <div data-id="element-2807">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2808">
                Shared By
              </h3>
              <div className="mt-2" data-id="element-2809">
                {Array.from(new Set(filteredDesigns.map(d => d.sharedBy))).map((person, index) => <div key={index} className="flex justify-between text-sm mb-1" data-id="element-2810">
                    <span data-id="element-2811">{person}</span>
                    <span className="font-medium" data-id="element-2812">
                      {filteredDesigns.filter(d => d.sharedBy === person).length}
                    </span>
                  </div>)}
              </div>
            </div>
            <div className="bg-blue-100 p-2 rounded-lg" data-id="element-2813">
              <UserIcon size={24} className="text-blue-600" data-id="element-2814" />
            </div>
          </div>
        </div>
      </div>

      {/* View type toggle */}
      <div className="flex justify-between items-center px-6 py-3 bg-white border-b border-gray-200" data-id="element-2815">
        <div className="text-gray-700 font-medium" data-id="element-2816">
          {filteredDesigns.length} shared designs
        </div>
        <div className="flex border border-gray-200 rounded-lg overflow-hidden" data-id="element-2817">
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'list' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('list')} data-id="element-2818">
            <ListIcon size={16} className="mr-1" data-id="element-2819" />
            List
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'grid' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('grid')} data-id="element-2820">
            <LayoutGridIcon size={16} className="mr-1" data-id="element-2821" />
            Grid
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'folders' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('folders')} data-id="element-2822">
            <FoldersIcon size={16} className="mr-1" data-id="element-2823" />
            Folders
          </button>
        </div>
      </div>

      {/* Designs view (grid, list, or folders) */}
      {viewType === 'folders' ? <div className="h-[calc(100vh-400px)] min-h-[400px]" data-id="element-2824">
          <FolderView designs={filteredDesigns} onViewDesign={handleViewDesign} data-id="element-2825" />
        </div> : viewType === 'grid' ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6" data-id="element-2826">
          {filteredDesigns.map(design => <DesignCard key={design.id} design={design} data-id="element-2827" />)}
          {filteredDesigns.length === 0 && <div className="col-span-3 text-center py-12 text-gray-500" data-id="element-2828">
              No shared designs found matching your search criteria
            </div>}
        </div> : <div className="overflow-x-auto" data-id="element-2829">
          <table className="w-full" data-id="element-2830">
            <thead className="bg-gray-50" data-id="element-2831">
              <tr data-id="element-2832">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2833">
                  ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2834">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2835">
                  Shared By
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2836">
                  Model
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2837">
                  Specs
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2838">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2839">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-2840">
              {filteredDesigns.map(design => <tr key={design.id} className="hover:bg-gray-50" data-id="element-2841">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2842">
                    {design.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2843">
                    <div className="font-medium" data-id="element-2844">{design.name}</div>
                    <div className="text-gray-500 text-xs" data-id="element-2845">
                      {design.description}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2846">
                    <div className="flex items-center" data-id="element-2847">
                      <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center mr-2" data-id="element-2848">
                        <UserIcon size={16} className="text-indigo-600" data-id="element-2849" />
                      </div>
                      <div data-id="element-2850">
                        {design.sharedBy}
                        <div className="text-xs text-gray-500" data-id="element-2851">
                          {design.date}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2852">
                    <div className="flex items-center" data-id="element-2853">
                      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-8 mr-2" data-id="element-2854" />
                      <div data-id="element-2855">
                        {design.model}
                        <div className="text-xs text-gray-500" data-id="element-2856">
                          {design.pivotCount}{' '}
                          {design.pivotCount === 1 ? 'unit' : 'units'}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2857">
                    <div className="flex gap-2 text-xs" data-id="element-2858">
                      <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full" data-id="element-2859">
                        {design.specs.length}
                      </span>
                      <span className="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full" data-id="element-2860">
                        {design.specs.area}
                      </span>
                      <span className="bg-teal-50 text-teal-700 px-2 py-0.5 rounded-full" data-id="element-2861">
                        {design.specs.flow}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2862">
                    <StatusBadge status={design.status} data-id="element-2863" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2864">
                    <div className="flex space-x-2" data-id="element-2865">
                      <button className="text-blue-600 hover:text-blue-800" data-id="element-2866">
                        <EyeIcon size={16} data-id="element-2867" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-2868">
                        <EditIcon size={16} data-id="element-2869" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-2870">
                        <ShareIcon size={16} data-id="element-2871" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
          {filteredDesigns.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-2872">
              No shared designs found matching your search criteria
            </div>}
        </div>}
    </div>;
}
// Helper component for design cards
function DesignCard({
  design
}) {
  const getStatusColor = status => {
    switch (status) {
      case 'active':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'completed':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'pending':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };
  return <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2873">
      <div className="p-5 border-b border-gray-100" data-id="element-2874">
        <div className="flex justify-between items-start" data-id="element-2875">
          <div data-id="element-2876">
            <div className="flex items-center" data-id="element-2877">
              <h3 className="font-bold text-gray-900 truncate max-w-[200px]" data-id="element-2878">
                {design.name}
              </h3>
              <span className="ml-2 bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full" data-id="element-2879">
                {design.id}
              </span>
            </div>
            <p className="text-gray-600 text-sm mt-1" data-id="element-2880">{design.description}</p>
          </div>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(design.status)}`} data-id="element-2881">
            {design.status.charAt(0).toUpperCase() + design.status.slice(1)}
          </span>
        </div>
        <div className="mt-4 flex items-center" data-id="element-2882">
          <div className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center mr-2" data-id="element-2883">
            <UserIcon size={16} className="text-indigo-600" data-id="element-2884" />
          </div>
          <div data-id="element-2885">
            <div className="text-sm font-medium text-gray-900" data-id="element-2886">
              Shared by: {design.sharedBy}
            </div>
            <div className="text-xs text-gray-500 flex items-center" data-id="element-2887">
              <CalendarIcon size={10} className="mr-1" data-id="element-2888" />
              {design.date}
            </div>
          </div>
        </div>
      </div>
      <div className="px-5 py-4 flex justify-between items-center bg-gray-50 border-b border-gray-100" data-id="element-2889">
        <div className="flex items-center" data-id="element-2890">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-12 mr-3" data-id="element-2891" />
          <div data-id="element-2892">
            <div className="text-sm font-medium text-gray-900" data-id="element-2893">
              {design.model}
            </div>
            <div className="text-xs text-gray-500" data-id="element-2894">
              {design.pivotCount} {design.pivotCount === 1 ? 'unit' : 'units'}
            </div>
          </div>
        </div>
      </div>
      <div className="px-5 py-4" data-id="element-2895">
        <h4 className="text-xs font-medium text-gray-500 mb-2" data-id="element-2896">
          SPECIFICATIONS
        </h4>
        <div className="grid grid-cols-3 gap-2" data-id="element-2897">
          <div className="bg-blue-50 rounded-lg p-2 text-center" data-id="element-2898">
            <div className="text-xs text-blue-600 mb-1 flex items-center justify-center" data-id="element-2899">
              <RulerIcon size={12} className="mr-1" data-id="element-2900" />
              Length
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-2901">
              {design.specs.length}
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-2 text-center" data-id="element-2902">
            <div className="text-xs text-indigo-600 mb-1 flex items-center justify-center" data-id="element-2903">
              <PieChartIcon size={12} className="mr-1" data-id="element-2904" />
              Area
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-2905">
              {design.specs.area}
            </div>
          </div>
          <div className="bg-teal-50 rounded-lg p-2 text-center" data-id="element-2906">
            <div className="text-xs text-teal-600 mb-1 flex items-center justify-center" data-id="element-2907">
              <DropletIcon size={12} className="mr-1" data-id="element-2908" />
              Flow
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-2909">
              {design.specs.flow}
            </div>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-1" data-id="element-2910">
          {design.tags.map((tag, index) => <span key={index} className="bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded-full flex items-center" data-id="element-2911">
              <TagIcon size={10} className="mr-1" data-id="element-2912" />
              {tag}
            </span>)}
        </div>
      </div>
      <div className="px-5 py-3 border-t border-gray-100 flex justify-between" data-id="element-2913">
        <div className="flex space-x-2" data-id="element-2914">
          <button className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center" data-id="element-2915">
            <EyeIcon size={14} className="mr-1" data-id="element-2916" />
            View
          </button>
          <button className="text-gray-600 hover:text-gray-800 text-sm font-medium flex items-center" data-id="element-2917">
            <EditIcon size={14} className="mr-1" data-id="element-2918" />
            Edit
          </button>
        </div>
        <div className="flex space-x-2" data-id="element-2919">
          <button className="text-gray-600 hover:text-gray-800" data-id="element-2920">
            <ShareIcon size={16} data-id="element-2921" />
          </button>
          <button className="text-gray-600 hover:text-gray-800" data-id="element-2922">
            <DownloadIcon size={16} data-id="element-2923" />
          </button>
        </div>
      </div>
    </div>;
}
// Helper component for status badges
function StatusBadge({
  status
}) {
  let config = {
    color: 'gray',
    text: 'Unknown'
  };
  switch (status) {
    case 'active':
      config = {
        color: 'blue',
        text: 'Active'
      };
      break;
    case 'completed':
      config = {
        color: 'green',
        text: 'Completed'
      };
      break;
    case 'pending':
      config = {
        color: 'amber',
        text: 'Pending'
      };
      break;
  }
  const colors = {
    blue: 'bg-blue-100 text-blue-800',
    green: 'bg-green-100 text-green-800',
    amber: 'bg-amber-100 text-amber-800',
    gray: 'bg-gray-100 text-gray-800'
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${colors[config.color]}`} data-id="element-2924">
      {config.text}
    </span>;
}